import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";

@Injectable({
  providedIn: "root"
})
export class UserSessionService {

  private baseUrl: string = this.config.protectedResourceEndpoint;
  private static readonly path: string = "usersession/";
  public onDisplayLoader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public onStartUpDisplayLoader$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {}

  setUsername$(username: string): Observable<any>
  {
    return this.http.get(this.baseUrl + UserSessionService.path + "setusername/"+username);
  }

  isUserNameActive$(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + UserSessionService.path + "isusernameactive");
  }
}
